import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import expandImg from './img/expand-img.avif';
import css from './CreatorsPage.module.css';

const SectionExpand = () => {
  return (
    <div className={css.sectionExpand}>
      <div className={css.expandContent}>
        <h2 className={css.expandTitle}>
          <FormattedMessage id="CreatorsPage.expandTitle" />
        </h2>
        <p className={css.expandText}>
          <FormattedMessage
            id="CreatorsPage.expandText"
            values={{
              textBreak: <br />,
            }}
          />
        </p>
      </div>
      <img className={css.expandImg} alt="Expand" src={expandImg} />
    </div>
  );
};

export default SectionExpand;
